import { Badge, Button, P } from '@fashionnovateam/nova-ui-toolkit';
import React, { useState } from 'react';
import { useCounterContext } from '../hooks/useCounter';
import CounterShippedDialog from '../dialogs/CounterShippedDialog';
import PrevSampleReceivedDialog from '../dialogs/PrevSampleReceivedDialog';
import {
  counterSampleStatusColorMapping,
  counterSampleStatusDisplayMapping,
  prevSampleStatusColorMapping,
  prevSampleStatusDisplayMapping,
} from '../types';

export type CounterDialogState = {
  counterShipped: boolean;
  prevSampleReceived: boolean;
  counterContacts: boolean;
};

function CounterInformation() {
  const { selectedCounter } = useCounterContext();
  const [dialogState, setDialogState] = useState<CounterDialogState>({
    counterShipped: false,
    prevSampleReceived: false,
    counterContacts: false,
  });
  const prevSampleStatusMapped =
    prevSampleStatusDisplayMapping[
      selectedCounter?.prev_sample_status as keyof typeof prevSampleStatusDisplayMapping
    ] || selectedCounter?.prev_sample_status;
  const counterSampleStatusMapped =
    counterSampleStatusDisplayMapping[
      selectedCounter?.counter_sample_status as keyof typeof counterSampleStatusDisplayMapping
    ] || selectedCounter?.counter_sample_status;

  const closeDialog = (dialogKey: keyof CounterDialogState) => {
    setDialogState((prev) => ({
      ...prev,
      [dialogKey]: false,
    }));
  };

  const openDialog = (dialogKey: keyof CounterDialogState) => {
    setDialogState((prev) => ({
      ...prev,
      [dialogKey]: true,
    }));
  };

  return (
    <>
      <CounterShippedDialog
        open={dialogState.counterShipped}
        handleClose={() => closeDialog('counterShipped')}
      />
      <PrevSampleReceivedDialog
        open={dialogState.prevSampleReceived}
        handleClose={() => closeDialog('prevSampleReceived')}
      />
      <div className="py-4 px-5 bg-neutral-0 flex flex-col gap-2">
        <div className=" flex justify-between items-center">
          <P size="sm" weight="medium">
            Previous Sample
          </P>
          <Badge
            contrast="low"
            color={
              prevSampleStatusColorMapping[
                prevSampleStatusMapped as keyof typeof prevSampleStatusColorMapping
              ] ?? 'neutral'
            }
          >
            {prevSampleStatusMapped}
          </Badge>
        </div>
        {prevSampleStatusMapped ===
          prevSampleStatusDisplayMapping.ShippedToVendor && (
          <Button
            onClick={() => openDialog('prevSampleReceived')}
            className="w-full"
            color="secondary"
          >
            Mark As Received
          </Button>
        )}
      </div>
      <div className="py-4 px-5 bg-neutral-0 flex flex-col gap-2">
        <div className=" flex justify-between items-center">
          <P size="sm" weight="medium">
            Vendor Sample
          </P>
          <Badge
            contrast="low"
            color={
              counterSampleStatusColorMapping[
                counterSampleStatusMapped as keyof typeof counterSampleStatusColorMapping
              ] ?? 'neutral'
            }
          >
            {counterSampleStatusMapped}
          </Badge>
        </div>
        {counterSampleStatusMapped ===
          counterSampleStatusDisplayMapping.Pending && (
          <Button
            onClick={() => openDialog('counterShipped')}
            className="w-full"
            color="secondary"
          >
            Mark As Shipped
          </Button>
        )}
      </div>
    </>
  );
}

export default CounterInformation;
